import React from 'react';
import {WizardField} from '../../../components/Wizard/QuestionWrapper';
import {ActionType} from '../../../components/AutoForm/AutoFieldNew';
import {postcursorFieldsType} from '../../PostcursorPage/postcursorFields';
import {ReviewDetailsFragment} from '../../../schema-types/ReviewDetailsFragment';
import {precursorAndHeaderFieldsType} from './precursorFields';
import {skippingAnnualReview} from './reviewAction';
import {AccountBasicFragment} from '../../../schema-types/AccountBasicFragment';

export const opportunityFields = (
  reviewDetails: ReviewDetailsFragment | undefined,
  account?: AccountBasicFragment | undefined
): WizardField<postcursorFieldsType | precursorAndHeaderFieldsType>[] => {
  const fields: WizardField<postcursorFieldsType | precursorAndHeaderFieldsType>[] = [
    {
      id: 'opportunityValue',
      title: 'Opportunity Value',
      question: 'Please provide an opportunity value.',
      questionComponent: (
        <>
          <ul>
            <li>Please input any new anticipated AUM</li>
            <li>
              If the review will not generate any new AUM, please input £0 (e.g. GIA to
              ISA)
            </li>
            <li>
              For protection cases, please input the fee revenue the case will generate
            </li>
          </ul>
        </>
      ),
      label: 'Opportunity Value',
      enabled: (values) => {
        const isSkipping = skippingAnnualReview(
          values as precursorAndHeaderFieldsType,
          reviewDetails
        );
        return !isSkipping;
      },
      type: ActionType.text,
      currency: true,
      initialValue:
        Number(reviewDetails?.opportunityValue) > 0
          ? reviewDetails?.opportunityValue
          : undefined,
      allowNegative: false,
      canBeEmpty: false,
      requireSubmit: true,
      validation: (val) => {
        if (Number.isNaN(val) || val === 'undefined' || !val) {
          return 'Value must be a number';
        }
        if (Number(val) < 0) {
          return 'Value must be a positive number';
        }
        return undefined;
      },
    },
  ];

  return fields;
};
